import { useState } from "react";

type TicketData = {
    field: string;
    value: any;
};

export function useTicketUpdateForm() {
    const [ticketData, setTicketData] = useState<TicketData[]>([]);
    const [subject, setSubject] = useState<string>("");
    const [comment, setComment] = useState<string>("");
    const [typeComment, setTypeComment] = useState<string>("");
    const [status, setStatus] = useState<string>("");
    const [type, setType] = useState<string>("");
    const [priority, setPriority] = useState<string>("");

    const typeMapping: Record<string, string> = {
        "pergunta": "question",
        "incidente": "incident",
        "problema": "problem",
        "tarefa": "task"
    };

    const handleFields = (field: string, value: string) => {
        const data = { field, value };
        setTicketData((prevData) => [...prevData, data]);
    };

    const handleSubject = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSubject(e.target.value);
    };

    const handleComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setComment(e.target.value);
    };

    const handleTypeComment = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTypeComment(e.target.value);
    };

    const handleStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        const standardStatuses = ["new", "open", "pending", "hold", "solved", "closed"];
        const field = standardStatuses.includes(value) ? "status" : "custom_status_id";
        const processedValue = field === "custom_status_id" ? parseInt(value) : value;
        setTicketData((prevData) => [...prevData, { field, value: processedValue }]);
        setStatus(value);
    };

    const handleType = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        if (value !== "-") {
            const englishValue = typeMapping[value] || value;
            setTicketData((prevData) => [...prevData, { field: "type", value: englishValue }]);
        }
        setType(value);
    };

    const handlePriority = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        if (value !== "-") {
            setTicketData((prevData) => [...prevData, { field: "priority", value }]);
        }
        setPriority(value);
    };

    function resetForm() {
        setTicketData([]);
        setSubject("");
        setComment("");
        setTypeComment("");
        setStatus("");
        setType("");
        setPriority("");
    }

    return {
        ticketData,
        subject,
        comment,
        typeComment,
        status,
        type,
        priority,
        handleFields,
        handleSubject,
        handleComment,
        handleTypeComment,
        handleStatus,
        handleType,
        handlePriority,
        resetForm
    }
}